// Variant 1 Text Only

import { LAYOUT_OPTIONS } from "../data";
import { FIRST_SLIDE_MASTER_BG, templates } from "../data/constant";
import { calculateFitDimensions, getWidthAndHeightFromUrl } from "./function";

// Default slide title options
const SLIDE_TITLE_OPTIONS = {
  x: 0.6, // Inside the border
  y: 0.8,
  fontSize: 28, // Smaller font size
  bold: true,
  color: "6058d0",
  align: "left",
};

// Adds title to slide with background
function addTitleIntoSlide(slide, title, isMaster, font) {
  const templateId = localStorage.getItem("PPT_BG_TEMPLATE_ID");
  const backgroundUrl = templates[templateId].background;
  if (isMaster === "MASTER") {
    slide.background = { path: FIRST_SLIDE_MASTER_BG };
  } else {
    slide.background = { path: backgroundUrl };
    slide.addText(title, {
      ...SLIDE_TITLE_OPTIONS,
      fontFace: font,
    });
  }
}

// Adds title above media elements
function addTitleAboveMedia(slide, title, x, y) {
  const font = localStorage.getItem("PPT_FONT");
  slide.addText(title, {
    ...SLIDE_TITLE_OPTIONS,
    fontSize: 16,
    x: x - 0.2,
    y: y - 0.2,
    bold: false,
    fontFace: font,
  });
}

function analyzeTextData(textArray) {
  let totalCharCount = 0;
  let totalWordsCount = 0;
  let totalObjLength = 0;
  const objectLengths = [];

  textArray.forEach((item) => {
    const textLen = item.text.length;
    const wordCount = item.text.split(/\s+/).length;

    totalCharCount += textLen;
    totalWordsCount += wordCount;
    totalObjLength += 1;

    objectLengths.push({
      textLen,
      wordCount,
    });
  });

  return {
    totalObjLength,
    objectLengths,
    totalWordsCount,
    totalCharCount,
  };
}

export function generateTextAndTableSlideV0(pptx, config, font) {
  console.info("Executing generateTextAndTableSlideV0");
  let slide = pptx.addSlide();
  addTitleIntoSlide(slide, config?.title, "MASTER");

  slide.addText(config?.title, {
    ...SLIDE_TITLE_OPTIONS,
    fontSize: 46,
    bold: true,
    color: "ffffff",
    x: "10%",
    y: "85%",
    align: "center",
    fontFace: font,
  });
}

// Generates slide with full text layout
export function generateTextAndTableSlideV1(pptx, config, font) {
  console.info("Executing generateTextAndTableSlideV1");
  let slide = pptx.addSlide();
  addTitleIntoSlide(slide, config?.title, "", font);

  config?.slideDataArray?.forEach((slideItem, index) => {
    if (slideItem?.type == "text") {
      const textOptions = {
        ...LAYOUT_OPTIONS.LAYOUT_1_FULL_MAX_TEXT_OPTIONS,
        fontFace: font,
      };

      if (Array.isArray(slideItem.data)) {
        // Update fontFace in each item's options
        console.log("slideItem.data", slideItem.data);
        const updatedData = slideItem.data.map((item) => ({
          ...item,
          options: {
            ...item.options,
            fontFace: font,
          },
        }));
        slide.addText(updatedData, textOptions);
      } else {
        // Handle non-array data
        slide.addText(slideItem.data, { ...textOptions, fontFace: font });
      }
    }
    if (slideItem?.type == "table") {
      if (slideItem.tableTitle) {
        const { x, y } = LAYOUT_OPTIONS.LAYOUT_1_MEDIA_FULL_OPTIONS_TABLE;
        addTitleAboveMedia(slide, slideItem.tableTitle, x, y);
      }

      const tableOptions = {
        ...LAYOUT_OPTIONS.LAYOUT_1_MEDIA_FULL_OPTIONS_TABLE,
        fontFace: font,
        _font: font,
      };

      slide.addTable(slideItem.data, tableOptions);
    }
    if (slideItem?.type == "chart") {
      if (slideItem.chartTitle) {
        const { x, y } = LAYOUT_OPTIONS.LAYOUT_1_MEDIA_FULL_OPTIONS_TABLE;
        addTitleAboveMedia(slide, slideItem.chartTitle, x, y);
      }

      slide.addChart(pptx.ChartType[slideItem.chartType], slideItem.data, {
        ...LAYOUT_OPTIONS.LAYOUT_1_MEDIA_FULL_OPTIONS_CHART,
        fontFace: font,
      });
    }
    if (slideItem?.type == "image") {
      const { width, height } = getWidthAndHeightFromUrl(slideItem.path);
      const newDimensions = calculateFitDimensions(width, height, 8.5, 4);

      slide.addImage({
        ...LAYOUT_OPTIONS.LAYOUT_1_MEDIA_FULL_OPTIONS_IMAGE,
        path: slideItem.path,
        w: newDimensions.width,
        h: newDimensions.height,
      });
    }
  });
}
const MAX_TEXT_LENGTH = 200;
// Generates slide with text on left and media on right
export function generateTextAndTableSlideV2(pptx, config, font) {
  console.info("Executing generateTextAndTableSlideV2");
  let slide = pptx.addSlide();
  slide.background = { color: "EFF212" };

  addTitleIntoSlide(slide, config?.title, "", font);

  config?.slideDataArray?.forEach((slideItem, index) => {
    const textProps = analyzeTextData(config?.slideDataArray[0]?.data);
    console.log("textProps", textProps);

    if (slideItem?.type == "text") {
      console.log("Output>>>", analyzeTextData(slideItem.data));

      const textOptions = {
        ...LAYOUT_OPTIONS.LAYOUT_2_MAX_TEXT_LEFT_OPTIONS_BULLET,
        w: textProps.totalCharCount > MAX_TEXT_LENGTH ? 4.8 : 2.4,
        fontFace: font,
      };
      console.log("textOptions for v2 is", textOptions);
      if (Array.isArray(slideItem.data)) {
        const updatedData = slideItem.data.map((item) => ({
          ...item,
          options: {
            ...item.options,
            fontFace: font,
          },
        }));
        slide.addText(updatedData, textOptions);
      } else {
        slide.addText(slideItem.data, { ...textOptions, fontFace: font });
      }
    }
    if (slideItem?.type == "table") {
      if (slideItem.tableTitle) {
        const { x, y } = LAYOUT_OPTIONS.LAYOUT_2_MEDIA_RIGHT_FULL_OPTIONS_TABLE;
        addTitleAboveMedia(slide, slideItem.tableTitle, x, y);
      }

      slide.addTable(slideItem.data, {
        ...LAYOUT_OPTIONS.LAYOUT_2_MEDIA_RIGHT_FULL_OPTIONS_TABLE,
        x: textProps.totalCharCount > MAX_TEXT_LENGTH ? 5.4 : 3.2,
        w: textProps.totalCharCount > MAX_TEXT_LENGTH ? 4.5 : 6.5,
        fontFace: font,
      });
    }
    if (slideItem?.type == "chart") {
      if (slideItem.chartTitle) {
        const { x, y } = LAYOUT_OPTIONS.LAYOUT_2_MEDIA_RIGHT_FULL_OPTIONS_CHART;
        addTitleAboveMedia(slide, slideItem.chartTitle, x, y);
      }

      slide.addChart(pptx.ChartType[slideItem.chartType], slideItem.data, {
        ...LAYOUT_OPTIONS.LAYOUT_2_MEDIA_RIGHT_FULL_OPTIONS_CHART,
        x: textProps.totalCharCount > MAX_TEXT_LENGTH ? 5.4 : 3.2,
        w: textProps.totalCharCount > MAX_TEXT_LENGTH ? 4.5 : 6.5,
        fontFace: font,
      });
    }
    if (slideItem?.type == "image") {
      const { width, height } = getWidthAndHeightFromUrl(slideItem.path);
      const maxAvailableWidth =
        textProps.totalCharCount > MAX_TEXT_LENGTH ? 6.5 : 4.5;
      const newDimensions = calculateFitDimensions(
        width,
        height,
        maxAvailableWidth,
        4
      );

      slide.addImage({
        ...LAYOUT_OPTIONS.LAYOUT_2_MEDIA_RIGHT_FULL_OPTIONS_IMAGE,
        path: slideItem.path,
        w: newDimensions.width,
        h: newDimensions.height,
        x: textProps.totalCharCount > MAX_TEXT_LENGTH ? 5.4 : 3.2,
      });
    }
  });
}

// Generates slide with text and table/chart/image combinations
export function generateTextAndTableSlideV4(pptx, config, font) {
  console.info("Executing generateTextAndTableSlideV4");
  let slide = pptx.addSlide();
  addTitleIntoSlide(slide, config?.title, "", font);
  const textProps = analyzeTextData(config?.slideDataArray[0]?.data);
  config?.slideDataArray?.forEach((slideItem, index) => {
    if (slideItem?.type == "text") {
      const textOptions = {
        ...LAYOUT_OPTIONS.LAYOUT_2_MAX_TEXT_LEFT_OPTIONS_BULLET,
        w: textProps.totalCharCount > MAX_TEXT_LENGTH ? 4.8 : 2.4,
        fontFace: font,
      };
      if (Array.isArray(slideItem.data)) {
        const updatedData = slideItem.data.map((item) => ({
          ...item,
          options: {
            ...item.options,
            fontFace: font,
          },
        }));
        slide.addText(updatedData, textOptions);
      } else {
        slide.addText(slideItem.data, { ...textOptions, fontFace: font });
      }
    }
    if (slideItem?.type == "table") {
      if (slideItem.tableTitle) {
        const { x, y } = {
          x: 5,
          y: index == 1 ? 0.5 : 2.4,
        };
        addTitleAboveMedia(slide, slideItem.tableTitle, x, y);
      }
      slide.addTable(slideItem.data, {
        ...{
          x: textProps.totalCharCount > MAX_TEXT_LENGTH ? 5.4 : 3.2,
          y: index == 1 ? 0.5 : 2.7,
          w: textProps.totalCharCount > MAX_TEXT_LENGTH ? 4.5 : 6.5,
          border: { pt: 1, color: "000000" },
          fontFace: font,
        },
      });
    }
    if (slideItem?.type == "chart") {
      if (slideItem.chartTitle) {
        const { x, y } = {
          x: 5,
          y: index == 1 ? 0.5 : 2.4,
        };
        addTitleAboveMedia(slide, slideItem.chartTitle, x, y);
      }
      slide.addChart(pptx.ChartType[slideItem.chartType], slideItem.data, {
        ...{
          x: textProps.totalCharCount > MAX_TEXT_LENGTH ? 5.4 : 3.2,
          y: index == 1 ? 0.5 : 3.1,
          w: textProps.totalCharCount > MAX_TEXT_LENGTH ? 4.5 : 6.5,
          h: 2.3,
          fontFace: font,
        },
      });
    }
    if (slideItem?.type == "image") {
      const { width, height } = getWidthAndHeightFromUrl(slideItem.path);
      const newDimensions = calculateFitDimensions(width, height, 4.5, 2.4);

      const newOptions = {
        x: textProps.totalCharCount > MAX_TEXT_LENGTH ? 5.4 : 3.2,
        y: index == 1 ? 0.5 : 3,
        path: slideItem.path,
        w: newDimensions.width,
        h: newDimensions.height,
      };

      slide.addImage({
        ...newOptions,
        path: slideItem.path,
      });
    }
  });
}

// Generates slide with text and side-by-side media elements
export function generateTextAndTableSlideV14(pptx, config, font) {
  console.info("Executing generateTextAndTableSlideV14");
  let slide = pptx.addSlide();
  addTitleIntoSlide(slide, config?.title, "_", font);
  const textProps = analyzeTextData(config?.slideDataArray[0]?.data);
  console.log("textProps v14", textProps);

  function getMediaXPosition(index) {
    return index == 1
        ? textProps.totalCharCount > MAX_TEXT_LENGTH
          ? 5.1
          : 3
        : textProps.totalCharCount > MAX_TEXT_LENGTH
        ? 7.5
        : 6.2
  }



  config?.slideDataArray?.forEach((slideItem, index) => {
    if (slideItem?.type == "text") {
      const textOptions = {
        ...LAYOUT_OPTIONS.LAYOUT_2_MAX_TEXT_LEFT_OPTIONS_BULLET,
        w: textProps.totalCharCount > MAX_TEXT_LENGTH ? 4.8 : 2.4,
        fontFace: font,
      };
      if (Array.isArray(slideItem.data)) {
        const updatedData = slideItem.data.map((item) => ({
          ...item,
          options: {
            ...item.options,
            fontFace: font,
          },
        }));
        slide.addText(updatedData, textOptions);
      } else {
        slide.addText(slideItem.data, { ...textOptions, fontFace: font });
      }
    }
    if (slideItem?.type == "table") {
      const newOptions = {
        x: getMediaXPosition(index),
        y: 0.5,
        w: textProps.totalCharCount > MAX_TEXT_LENGTH ? 2.25 : 3.5,
        border: { pt: 1, color: "000000" },
        fontFace: font,
      };
      const { x, y } = newOptions;
      if (slideItem.tableTitle) {
        addTitleAboveMedia(slide, slideItem.tableTitle, x, y);
      }
      slide.addTable(slideItem.data, {
        ...newOptions,
      });
    }
    if (slideItem?.type == "chart") {
      const newOptions = {
        x: getMediaXPosition(index),
        y: 0.5,
        w: textProps.totalCharCount > MAX_TEXT_LENGTH ? 2.25 : 3,
        fontFace: font,
      };
      console.log('for index newOptions v14 chart',index, newOptions)
      if (slideItem.chartTitle) {
        const { x, y } = newOptions;
        addTitleAboveMedia(slide, slideItem.chartTitle, x, y);
      }
      slide.addChart(pptx.ChartType[slideItem.chartType], slideItem.data, {
        ...newOptions,
      });
    }
    if (slideItem?.type == "image") {
      const { width, height } = getWidthAndHeightFromUrl(slideItem.path);
      const newDimensions = calculateFitDimensions(
        width,
        height,
        textProps.totalCharCount > MAX_TEXT_LENGTH ? 2.3 : 3,
        4.5
      );

      console.log('for index newDimensions',newDimensions)
      

      
      console.log('getXPosition for index ',index, getMediaXPosition(index))

      const newOptions = {
        x: getMediaXPosition(index),
        y: 0.5,
        path: slideItem.path,
        w: newDimensions.width,
        h: newDimensions.height,
      };
      console.log('for index newOptions',newOptions)
      slide.addImage({
        ...newOptions,
        path: slideItem.path,
      });
    }
  });
}

// Generates slide with less text and two landscape media elements
export function generateTextAndTableSlideV9(pptx, config, font) {
  console.info("Executing generateTextAndTableSlideV9");
  let slide = pptx.addSlide();
  addTitleIntoSlide(slide, config?.title, "_", font);

  config?.slideDataArray?.forEach((slideItem, index) => {
    if (slideItem?.type == "table") {
      const newOptions = {
        ...slideItem.options,
        y: index == 0 ? 0.8 : 3.3,
        h: index == 0 ? 2.1 : 2.2,
        fontFace: font,
      };

      if (slideItem.tableTitle) {
        const { x, y } = newOptions;
        addTitleAboveMedia(slide, slideItem.tableTitle, x, y);
      }

      slide.addTable(slideItem.data, {
        ...newOptions,
      });
    }
    if (slideItem?.type == "chart") {
      if (slideItem.chartTitle) {
        const { x, y } = {
          x: 1,
          y: index == 0 ? 1.3 : 3.5,
          w: 8.5,
          h: 2,
        };
        addTitleAboveMedia(slide, slideItem.chartTitle, x, y);
      }
      slide.addChart(pptx.ChartType[slideItem.chartType], slideItem.data, {
        ...{
          x: 1,
          y: index == 0 ? 1.3 : 3.5,
          w: 8.5,
          h: 2,
          fontFace: font,
        },
      });
    }
    if (slideItem?.type == "image") {
      const { width, height } = getWidthAndHeightFromUrl(slideItem.path);
      const newDimensions = calculateFitDimensions(width, height, 8.5, 2.1);

      slide.addImage({
        x: 1,
        y: index == 0 ? 0.8 : 3.3,
        path: slideItem.path,
        w: newDimensions.width,
        h: newDimensions.height,
      });
    }
  });
}

// Generates slide with portrait layout for two media elements
export function generateTextAndTableSlideV19(pptx, config, font) {
  console.info("Executing generateTextAndTableSlideV19");
  let slide = pptx.addSlide();
  addTitleIntoSlide(slide, config?.title, "_", font);

  config?.slideDataArray?.forEach((slideItem, index) => {
    if (slideItem?.type == "table") {
      const newOptions = {
        ...slideItem.options,
        x: index == 0 ? 0.5 : 5,
        y: 1,
        w: 4,
        fontFace: font,
      };
      delete newOptions.h;

      if (slideItem.tableTitle) {
        const { x, y } = newOptions;
        addTitleAboveMedia(slide, slideItem.tableTitle, x, y);
      }

      slide.addTable(slideItem.data, {
        ...newOptions,
      });
    }
    if (slideItem?.type == "chart") {
      if (slideItem.chartTitle) {
        const { x, y } = {
          x: index == 0 ? 0.5 : 5,
          y: 1,
        };
        addTitleAboveMedia(slide, slideItem.chartTitle, x, y);
      }
      slide.addChart(pptx.ChartType[slideItem.chartType], slideItem.data, {
        ...{
          x: index == 0 ? 0.5 : 5,
          y: 1,
          w: 4,
          fontFace: font,
        },
      });
    }
    if (slideItem?.type == "image") {
      const { width, height } = getWidthAndHeightFromUrl(slideItem.path);
      const newDimensions = calculateFitDimensions(width, height, 4, 5);

      slide.addImage({
        x: index == 0 ? 0.5 : 5,
        y: 1,
        path: slideItem.path,
        w: newDimensions.width,
        h: newDimensions.height,
      });
    }
  });
}
